"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetWifiRequestT = exports.SetWifiRequest = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class SetWifiRequest {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsSetWifiRequest(bb, obj) {
        return (obj || new SetWifiRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsSetWifiRequest(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new SetWifiRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    ssid(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    password(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startSetWifiRequest(builder) {
        builder.startObject(2);
    }
    static addSsid(builder, ssidOffset) {
        builder.addFieldOffset(0, ssidOffset, 0);
    }
    static addPassword(builder, passwordOffset) {
        builder.addFieldOffset(1, passwordOffset, 0);
    }
    static endSetWifiRequest(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createSetWifiRequest(builder, ssidOffset, passwordOffset) {
        SetWifiRequest.startSetWifiRequest(builder);
        SetWifiRequest.addSsid(builder, ssidOffset);
        SetWifiRequest.addPassword(builder, passwordOffset);
        return SetWifiRequest.endSetWifiRequest(builder);
    }
    unpack() {
        return new SetWifiRequestT(this.ssid(), this.password());
    }
    unpackTo(_o) {
        _o.ssid = this.ssid();
        _o.password = this.password();
    }
}
exports.SetWifiRequest = SetWifiRequest;
class SetWifiRequestT {
    constructor(ssid = null, password = null) {
        this.ssid = ssid;
        this.password = password;
    }
    pack(builder) {
        const ssid = (this.ssid !== null ? builder.createString(this.ssid) : 0);
        const password = (this.password !== null ? builder.createString(this.password) : 0);
        return SetWifiRequest.createSetWifiRequest(builder, ssid, password);
    }
}
exports.SetWifiRequestT = SetWifiRequestT;
